import { useTranslation } from "react-i18next";

import BasicExamTypeFilter from "./BasicExamTypeFilter";

export default function ExamTypeFilter(props) {
	const { t } = useTranslation();

	return (
		<BasicExamTypeFilter
			{...props}
			filters={[
				{
					label: t("filters.exams.typeOfExam.lek.cem.title"),
					hint: t("filters.exams.typeOfExam.lek.cem.hint"),
				},
				{
					label: t("filters.exams.typeOfExam.lek.all.title"),
					hint: t("filters.exams.typeOfExam.lek.all.hint"),
				},
			]}
		/>
	);
}
